import React, { useState } from 'react';
import { CnRadioGroup } from '@cainiaofe/cn-ui';

import './index.scss';

const AiAgreeCheck = (props) => {
  const { title = '您是否同意系统获取已上传的简历信息进行智能推荐？', handleConfirm } = props;
  const [value, setValue] = useState();

  return (
    <div className="ai-agree-check-wrap">
      <div>{title}</div>
      <div className="ai-agree-check-bottom">
        <CnRadioGroup
          shape="tag"
          value={value}
          onChange={(v) => {
            if (value) return;
            setValue(v);
            handleConfirm && handleConfirm(v);
          }}
          dataSource={[
            { label: '同意', value: 'agree' },
            {
              label: '不同意',
              value: 'disagree',
            },
          ]}
        />
      </div>
    </div>
  );
};

export default AiAgreeCheck;
